/**
 *  商品表
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/19      1.0    First version   使用统一的表格组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React from 'react'
import { Spin, Button, message} from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import GoodsListEdit from "./common/GoodsListEdit";
import PropTypes from "prop-types";
import History from "./common/History";
import DownloadBtnModal from "./common/DownloadBtnModal";
import HistoryBtnModal from './common/HistoryBtnModal';
import ConfirmAlert from './common/ConfirmAlert'
import {getInfo} from "./common/Info";
import { isEmpty} from '@utils/utils';
import dayjs from 'dayjs';
import UploadFile from '@/components/UploadFile/UploadFile';
import {postGoodsOrderExcel,postGoodsSubOrderExcel} from "@/api/ShipperManagement";
import PageCommon from  "@components/PageCommon/PageCommon";


export default class GoodsListAndSubEdit extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
        fetchApi:PropTypes.string.isRequired, // 查询表格API
        saveApi: PropTypes.string.isRequired, // 保存数据API
    }
    static defaultProps = {
        orderType:'',
        fetchApi:'',
        saveApi:''
    }
    constructor(props) {
        super(props);
        this.state = {
            //上传的文件
            fileList:[],
            list:[],
            orderInfo: {},
            loading:false,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
            //mg-价格表恢复接口 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=170#7419
            recoverUrl: props.orderType=='goods_sub'?'/service/mg/con/report/goods-sub-order/recovery-version':' /service/mg/con/report/goods-order/recovery-version',
            // 列
            columns : [
                {
                    cnTitle: '编号',
                    cnTitleId: 'BianHao',
                    dataIndex: "id",
                    width:100,
                    render: (text, item, index) => {
                        return (<span>{index+1}</span>)
                    }
                },
                {
                    cnTitle: '发票上的编号',
                    cnTitleId: 'FaPiaoShangDeBianHao',
                    width:140,
                    dataIndex:'index',
                    render: (text, item, index) => {
                        return (<span>{item.billCode}</span>)
                    }
                },
                {
                    cnTitle: '海关代码',
                    width:120,
                    cnTitleId: 'HaiGuanDaiMa',
                    dataIndex: "customsCode"
                },
                {
                    cnTitle: '商品编号',
                    width:140,
                    cnTitleId: 'ShangPinBianHao',
                    dataIndex: "skuNo"
                },
                {
                    cnTitle: '产品描述',
                    cnTitleId: 'ChanPinMiaoShu',
                    dataIndex: "goodsDesc",
                    width: 250,
                },
                {
                    cnTitle: '制造商',
                    cnTitleId: 'ZhiZaoShang',
                    width:200,
                    dataIndex: "stickerProducer"
                },
                {
                    cnTitle: '商标',
                    cnTitleId: 'ShangBiao',
                    dataIndex: "stickerTrademark",
                    width: 100,
                },
                {
                    cnTitle: '品牌',
                    cnTitleId: 'PinPai',
                    dataIndex: "brandName",
                    width: 100,
                },
                {
                    cnTitle: '型号',
                    cnTitleId: 'XingHao',
                    dataIndex: "model",
                    width: 100,
                },
                {
                    title:Lang({id: "ZongShuLiang",default: "总数量"})+ '（PCS）',
                    dataIndex: "total",
                    width: 150,
                },
                {
                    cnTitle: '代码单位',
                    cnTitleId: 'DaiMaDanWei',
                    dataIndex: "codeUnit",
                    width: 100,
                },
                {
                    cnTitle: '计量单位',
                    cnTitleId: 'JiLiangDanWei',
                    dataIndex: "measureUnit",
                    width: 100,
                },
                {
                    cnTitle: '总箱数',
                    cnTitleId: 'ZongXiangShu',
                    dataIndex: "totalDeliveryQuantity",
                    width: 100,
                },
                {
                    title:Lang({id: "ZongMaoZhong",default: "总毛重"})+ ' kg',
                    dataIndex: "totalGrossWeight",
                    width:150,
                },
                {
                    title:Lang({id: "ZongJingZhong",default: "总净重"})+ ' kg',
                    dataIndex: "totalNetWeight",
                    width:150,
                },
                {
                    title:Lang({id: "ChengBen",default: "成本"})+ ' USD',
                    dataIndex: "cost",
                    width:150,
                },
                {
                    cnTitle: '价格转换',
                    cnTitleId: 'JiaGeZhuanHuan',
                    dataIndex: "priceConversion",
                    width:150,
                },
                {
                    title:Lang({id: "YunShu",default: "运输"})+ ' USD',
                    dataIndex: "transportationCostUsd",
                    width:150,
                },
                {
                    cnTitle: '运输重新计算',
                    cnTitleId: 'YunShuChongXinJiSuan',
                    dataIndex: "recalculateTransportation",
                    width:150,
                },
                {
                    cnTitle: '海关税率',
                    cnTitleId: 'HaiGuanShuiLv',
                    dataIndex: "customsClearanceRate",
                    width:150,
                },
                {
                    cnTitle: '费用(重新计算)',
                    cnTitleId: 'FeiYongChongXinJiSuan',
                    dataIndex: "customsClearanceValueRate",
                    width:150,
                },
                {
                    cnTitle: '增值税率',
                    cnTitleId: 'ZengZhiShuiLv',
                    dataIndex: "importTariffRate",
                    width:150,
                },
                {
                    cnTitle: '增值税(重新计算)',
                    cnTitleId: 'ZengZhiShuiChongXinJiSuan',
                    dataIndex: "recalculateImportTariffRate",
                    width:150,
                },
                {
                    cnTitle: '许可证文件',
                    width:150,
                    cnTitleId: 'XuKeZhengWenJian',
                    dataIndex: "licenseFile"
                },
                {
                    cnTitle: '开始日期',
                    width:150,
                    cnTitleId: 'KaiShiRiQi',
                    render: (text, item, index) => {
                        return (<span>{item.beginTime?dayjs(item.beginTime).format('YYYY-MM-DD'):''}</span>)
                    }
                },
                {
                    cnTitle: '结束日期',
                    width:150,
                    cnTitleId: 'JieShuRiQi',
                    render: (text, item, index) => {
                        return (<span>{item.endTime?dayjs(item.endTime).format('YYYY-MM-DD'):''}</span>)
                    }
                },
            ],
            canEdit:false,
            // 商品列表 数据
            goodsOrderList:[],
            noDescNum:0
        }
    }
    /**
     * 统计
     **/
    count(keyName,list,fixed=0){
        let count = 0;
        for(let i=0;i<list.length;i++){
            let item = list[i];
            count+= Number(item[keyName]);
        }
        return count?count.toFixed(fixed):'-';
    }
    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            isShowHistoryId:item.id,
        })
    }

    /**
     * 隐藏历史记录面板
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
        })
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        const {orderType} = this.props;
        if(res&&res.model){
            const data = res.model||{}
            let list = [],orderInfo = {}
            if(orderType=='goods'){ //商品单 表格行数据
                orderInfo=data;
                list =  data.goodsOrderList||[];
            }else if(orderType=='goods_sub'){//样品商品单 表格行数据
                orderInfo=data.orderInfo;
                list = data.goodsSubOrderItemList||[];
            }
            const noDescList = list.filter(item=>isEmpty(item.goodsDesc))
            this.setState({
                orderInfo: orderInfo,
                goodsOrderList: list,
                noDescNum: noDescList.length
            })

        }
    }
    /**
     * 编辑
     * */
    edit(flag=true){
        this.setState({
            canEdit: flag,
        })
        this.props.handleEdit(flag)
    }

    /**
     * mg-上传excel
     **/
    uploadFileCallBack(fileList){
        //商品表
        let api = postGoodsOrderExcel;
        //样品商品表
        if(this.props.orderType=='goods_sub'){
            api = postGoodsSubOrderExcel;
        }
        api({
            fileId:fileList[0].fileId,
            goodsOrderId:this.state.orderInfo.id,
            containerId:this.props.containerId
        }).then((res)=>{
            this.setState({
                fileList:[]
            },()=>{
                if(res.data.valid&&res.data.success){
                    message.success(Lang({id: "ShangChuanChengGong",default:'上传成功'}));
                    this.getData();
                }else{
                    if(res.data.message){
                        message.info(res.data.message);
                    }
                }
            })
        })
    }

    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { orderInfo,loading,columns, isShowHistoryPanel, canEdit,recoverUrl,goodsOrderList,noDescNum} = this.state;
        const {orderType,containerId,downloadUrlExcel,downloadUrlPdf,fetchApi,callBackFields,pageTitle,saveApi} = this.props;
        const uploadSetting = {
            replace:true,
            accept:'xls,xlsx',
            showUploadList:false,
        }
        let btnList = [];

        if(!isShowHistoryPanel && !canEdit){
            btnList= [
                { 
                    btn: <span>{Lang({id: "BianJi",default: "编辑"})}</span>,
                    icon:"ri-quill-pen-line color-blue mr_4",
                    btnClick:()=>this.edit()
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-blue mr_4'></i>
                        {Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                    </div> }
                    downloadUrl={downloadUrlExcel}
                    orderInfo={orderInfo} />,
                    btnClick:()=>{}
                },{ 
                    btn: 
                        <UploadFile {...uploadSetting} initValue={this.state.fileList}
                            onChange={(fileList)=>{
                                this.uploadFileCallBack(fileList);
                            }}>
                                <i className='ri-upload-cloud-line mr_4 color-green'></i><span className={"margin-left-5"}>{Lang({id:'ShangChuanTianCong',default:'上传填充'})}</span>
                            </UploadFile>
                    ,
                    btnClick:()=>{}
                },
                { 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                },
            ]
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }




        return (canEdit?<GoodsListEdit orderInfo={orderInfo}
                                       orderType={orderType}
                                       loading={this.loading.bind(this)}
                                       containerId={containerId}
                                       type={orderType=='goods'?'2':'1'} // 类型2目的为显示 不一样的orderInfo结构,goods:model, goods-goods_sub:model.orderInfo
                                       saveApi={saveApi}
                                       edit={this.edit.bind(this)}
                                       goodsOrderList={goodsOrderList} />:<div className={"packListWrap"}>
                {isShowHistoryPanel?<History id={this.state.isShowHistoryId} orderType={orderType}
                                             title={pageTitle}
                                             type={orderType=='goods'?'2':'1'} // 类型2目的为显示 不一样的orderInfo结构,goods:model, goods-goods_sub:model.orderInfo
                                             loading={loading}
                                             columns = {columns}
                                             showRecover={true}
                                             recoverUrl={recoverUrl}
                                             callBackFields = {callBackFields}
                                             fetchApi={fetchApi}
                                             callBack={this.hideHistoryPanel.bind(this)} />:<PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
                                             <Spin spinning={loading}>
                                                <AutoFetchTable columns={columns}
                                                                onRef={this.onRefTabOne}
                                                                callBackFields = {callBackFields}
                                                                paginationFlag={false}
                                                                bordered={true}
                                                                scroll={{ x:1100}}
                                                                fetchCallBack={(res)=>this.setOrderInfo(res)}
                                                                precondition={{containerId:containerId}}
                                                                fetchApi={fetchApi} >
                                                    {/* 预览内容 */}
                                                    {orderInfo&&orderInfo.id&&<div>
                                                        {/*操作区*/}
                                                        {/* <div className={"flex-item fixed-footer__wrap"}>
                                                            <Button onClick={()=>this.edit()}>{Lang({id: "BianJi",default: "编辑"})}</Button>
                                                            <DownloadBtnModal title={Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                                                                            className={"margin-left-5"}
                                                                            downloadUrl={downloadUrlExcel}
                                                                            orderInfo={orderInfo} />

                                                            <UploadFile {...uploadSetting} initValue={this.state.fileList}
                                                                        onChange={(fileList)=>{
                                                                            this.uploadFileCallBack(fileList);
                                                                        }}>
                                                                <Button className={"margin-left-5"}>{Lang({id:'ShangChuanTianCong',default:'上传填充'})}</Button>
                                                            </UploadFile>
                                                            <DownloadBtnModal title={Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                                                                            className={"margin-left-5"}
                                                                            downloadUrl={downloadUrlPdf}
                                                                            type={'pdf'}
                                                                            orderInfo={orderInfo} />
                                                            <HistoryBtnModal className={"margin-left-5"}
                                                                            title={pageTitle+Lang({id: 'LiShiJiLu', default: '历史记录'})}
                                                                            orderType={orderType}
                                                                            recoverUrl={recoverUrl}
                                                                            showRecover={true}
                                                                            recoveryHistoryBack={this.getData.bind(this)}
                                                                            showHistoryPanel={item=>this.showHistoryPanel(item)}
                                                                            containerId={containerId} />
                                                            <ConfirmAlert tipsNum={noDescNum} orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />
                                                            {noDescNum>0?<span className={"tips margin-left-5"}>{Lang({id: "KuanShangPinMiaoShuWeiWanShan",default: "{0}款商品描述未完善",params:[noDescNum]})}</span>:null}
                                                        </div> */}
                                                        {/* 表头 公司名称英文、中文、地址、注释*/}
                                                        {getInfo(orderType,orderInfo)}
                                                        {noDescNum>0?<p className={"tips margin-left-5"}>{Lang({id: "KuanShangPinMiaoShuWeiWanShan",default: "{0}款商品描述未完善",params:[noDescNum]})}</p>:null}
                                                        {/* <p style={{lineHeight:'20px'}}>123123</p> */}
                                                        {/* 表头 END */}
                                                    </div>}
                                                </AutoFetchTable>
                                             </Spin>
                                             </PageCommon> }
            </div>
        )
    }
}
